<template>
  <div>
    <div class="l-container">
      <div style="display: flex; align-items: center; padding: 4.5px 0">
        <h1 class="m-name">[{{appointment.id}}] {{appointment.f_name}} {{appointment.l_name}}({{appointment.f_name_kana}} {{appointment.l_name_kana}}) 様</h1>

        <template v-if="appointment.family">

          <template v-if="appointment.family">
            <router-link :to="{ name: 'familyindex', params: { id: appointment.family.id }, exact: true }">
              <i class="fa fa-home"></i>
            </router-link>
          </template>

        </template>

      </div>

      <!-- <section&#45;navi> -->
      <!--   <section&#45;item> -->
      <!--     <div @click="name('appointmentindex2')"> -->
      <!--       <router&#45;link :to="{ name: 'appointmentindex2', params: { id: appointment.id }, exact: true }" exact> -->
      <!--         データ -->
      <!--       </router&#45;link> -->
      <!--     </div> -->
      <!--   </section&#45;item> -->
      <!--  -->
      <!--   <section&#45;item> -->
      <!--     <div @click="name('appointmentmap2')"> -->
      <!--       <router&#45;link :to="{ name: 'appointmentmap2', params: { id: appointment.id } }"> -->
      <!--         地図 -->
      <!--       </router&#45;link> -->
      <!--     </div> -->
      <!--   </section&#45;item> -->
      <!--  -->
      <!--   <section&#45;item> -->
      <!--     <div @click="name('appointmenthistory2')"> -->
      <!--       <router&#45;link :to="{ name: 'appointmenthistory2', params: { id: appointment.id } }"> -->
      <!--         対応履歴 -->
      <!--       </router&#45;link> -->
      <!--     </div> -->
      <!--   </section&#45;item> -->
      <!--  -->
      <!--   <section&#45;item> -->
      <!--     <router&#45;link :to="{ name: 'printap', exact: true }">APカード</router&#45;link> -->
      <!--   </section&#45;item> -->
      <!--  -->
        <!-- <section&#45;item> -->
        <!--   <appointment&#45;gmail :appointment="appointment"></appointment&#45;gmail> -->
        <!-- </section&#45;item> -->
        <!--  -->
        <!-- <section&#45;item> -->
        <!--   <appointment&#45;gmail&#45;support :appointment="appointment"></appointment&#45;gmail&#45;support> -->
        <!-- </section&#45;item> -->
      <!--  -->
      <!-- </section&#45;navi> -->
      <router-view :appointment="appointment" :condition="condition" :edit_id="edit_id"></router-view>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue'
export default {
  props: {
    routeName: Object
  },

  data () {
    return {
      edit_id: {
        appointment_id: '',
        list_id: ''
      },
      condition: {
        condition: false
      },

      // getGeo用
      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ]
    }
  },

  computed: {
    appointment () {
      return this.$store.getters.appointment
    },
    param () {
      return this.$route.params
    }
  },

  methods: {
    name (val) {
      console.log(val)
      this.routeName.name = val
    },

    getGeo () {
      this.$store.dispatch('getGeo', {
        this: this,
        appointment: this.appointment,
        pref: this.pref
      })
    },

    // getAppointment (id) {
    //   Vue.delete(this.appointment, 'familysupports')
    //   this.$store.dispatch('getAppointment', id)
    // },

    getTags () {
      this.$store.dispatch('getTags')
    },

    getUsers (id) {
      this.$store.dispatch('getUsers', id)
    },

    getOffices (id) {
      this.$store.dispatch('getOffices', id)
    },

    getPrefs (id) {
      this.$store.dispatch('getPrefs', id)
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getAppointment(to.params.id)
      vm.getTags(to)
      vm.getUsers(to.params.id)
      vm.getOffices(to.params.id)
      vm.getPrefs(to.params.id)
    })
  }
}
</script>

<style lang="scss" scoped>
.m-name {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// Appointment2.vue?5ba0bd72